/**
 * @ngdoc filters
 * @memberof mercury.filters
 * @name timelength
 */
angular.module('mercury.filters.timelength', [])
.filter('timelength', function() {
  return function(hours) {
    var result = Math.trunc(hours) + ' hrs';

    var minutes = Math.round((hours * 60) % 60);
    if (minutes !== 0) {
      result += ' ' + minutes + ' mins';
    }

    return result;
  };
});
